/* jshint undef: true, unused: true */
/* globals AddNewFloatingDiv */

var nJ = require('../../../../js_functions/form-builder/js/not-jquery'),
    ContentManagementDisplay = require('../../../../js_functions/form-builder/js/content-management-display-form'),
    Translation = require('../../../../js_functions/medsEquipmentsTranslation'),
    irmFunctions = require('../irm-shared-functions'),
    FormBuilderStructure = require('./medications_form-builder-structure'),
    MedsDisplayStructure = require('./medications_display-structure'),
    MedsGraphqlService = require('./medications-graphql-service'),
    uuidWrapper = require('../../../../js_functions/uuid-wrapper');

const globals = require('../../../../js_functions/globalsWrapper')();
const medsRESTService = require('./medications-rest-service');

// API functions are flagged by whether the REST functionality is implemented.
// Once they are all implemented, the flags can be removed.
// Once everyone is switched to REST, the global switch can be removed.
const medsAPIService = Object
  .entries({
    deleteMedication     : false,
    getDrugSearchResults : true,
    submitMedication     : false,
    getDrugAnswers       : false,
    nextPage: true,
    previousPage: true,
    hasPreviousPage: true,
    hasNextPage: true,
  })
  .map(entry => {
    const [name, hasREST] = entry;
    return {
      name,
      hasREST,
    };
  })
  .reduce((service, data) => {
    service[data.name] = (data.hasREST ? medsRESTService : new MedsGraphqlService(MedsDisplayStructure))[data.name];
    return service;
  }, {});

var // Classes
    translations           = new Translation('medications'),
    contentTable,
    // Variables
    uidPrefix              = 'medications',
    drugRecordNsUuid       = 'c8112a20-b996-4aec-b267-bd0cb9affc71',
    incidentRecordNsUuid   = globals.incidentRecordNsUuid,
    searchModal,
    formStructure,
    tableOptions,
    domId,
    // Functions
    initInputWithButton,
    getDrugAnswersAndBuildTable,
    getDrugAnswersAndBuildTableSuccessCallback,
    getDrugAnswersAndBuildTableErrorCallback,
    restructureExistingData,
    getMedicationSearchResults,
    searchResultSuccessCallback,
    searchResultErrorCallback,
    clearAdministeredFields,
    clearIntendedFields,
    clearFields,
    duplicateAdministeredFields,
    processInputsFunction,
    submitRecord,
    onDrugSubmissionSuccessCallback,
    onDrugSubmissionErrorCallback,
    onDrugDeletionSuccessCallback,
    onDrugDeletionErrorCallback,
    hideSuperfluousHeader,
    getDrugChoseIdentifier,
    drugChoseEventHandler,
    submitRecordErrorCallback;

hideSuperfluousHeader = function () {
  $('#medication').hide();
};

initInputWithButton = function (targetInput, targetInputAddonElement, foBu) {
  var inputSettings = targetInput.foBuSettings,
      updateDependentProps = inputSettings.onUpdateDependentValues;

  irmFunctions.initInputWithButton(targetInput, targetInputAddonElement, getMedicationSearchResults);

  drugChoseEventHandler(targetInput, updateDependentProps, foBu);
};


// REFACTOR SUGGESTION: Move to irm-shared-functions.js
// Pass language strings in as parameters
function instantiateCancelFormDialogue(event, isEdited) {
  event.stopPropagation();
  event.preventDefault();

  var id      = 'inc-medications--add-medication-dialog__cancel',
      title   = translations.translateString('MEDICATIONS.V2.FORM.MESSAGE.CANCEL_MEDICATION.TITLE'),
      content = translations.translateString('MEDICATIONS.V2.FORM.MESSAGE.CANCEL_MEDICATION.CONTENT'),
      modal   = AddNewFloatingDiv(id);

  modal.setTitle(title);
  modal.setContents('<div>' + content + '</div>');

  modal.setSizeModify({'width': 300});

  modal.setButtons([
    {
      value   : translations.translateString('MEDICATIONS.V2.FORM.BUTTON.CANCEL.CANCEL'),
      onclick : modal.CloseFloatingControl.bind(modal)
    },
    {
      value   : translations.translateString('MEDICATIONS.V2.FORM.BUTTON.CANCEL.OK'),
      class   : 'button-primary',
      onclick : function() {
        modal.CloseFloatingControl();
        contentTable.closeForm(isEdited);
      }
    }
  ]);

  modal.display();

  return modal;
}

function instantiateDeleteMedicationDialogue(event) {
  event.stopPropagation();
  event.preventDefault();
  const id        = 'inc-medications--add-medication-dialog__cancel';
  const title     = translations.translateString('MEDICATIONS.V2.FORM.MESSAGE.DELETE_MEDICATION.TITLE');
  const content   = translations.translateString('MEDICATIONS.V2.FORM.MESSAGE.DELETE_MEDICATION.CONTENT');
  const modal     = AddNewFloatingDiv(id);
  const recordId  = event.target.dataset.recordId;
  let answersId   = event.target.dataset.answersId;

  modal.setTitle(title);
  modal.setContents('<div>' + content + '</div>');

  modal.setSizeModify({'width': 300});

  modal.setButtons([
    {
      value   : translations.translateString('MEDICATIONS.V2.FORM.BUTTON.DELETE_MEDICATION.CANCEL'),
      onclick : modal.CloseFloatingControl.bind(modal)
    },
    {
      value   : translations.translateString('MEDICATIONS.V2.FORM.BUTTON.DELETE_MEDICATION.OK'),
      class   : 'button-warning',
      onclick : function() {
        const cmt = this;
        const params = {
          answersId    : answersId,
          recordId     : recordId,
          deleteRecord : cmt.deleteRecord
        };

        modal.CloseFloatingControl();
        window.displayLoadPopup();
        medsAPIService.deleteMedication(params, onDrugDeletionSuccessCallback, onDrugDeletionErrorCallback);
      }.bind(this)
    }
  ]);

  modal.display();

  return modal;
}

function showSearchResultsDialog(data, targetInput) {
  var title           = translations.translateString('MEDICATIONS.V2.MESSAGE.SEARCH_RESULTS.TITLE'),
      modal           = AddNewFloatingDiv('matching-medication'),
      dataLength      = Object.keys(data).length,
      targetInputName = targetInput.name,
      invalidLocation = data.invalidLocation || false;

  modal.setTitle(title);
  switch (true) {
    case invalidLocation:
      modal.setContents(noMatchesFoundContent(true));

      break;
    case dataLength > 0:
      setPaginationButtons(modal, targetInputName);

      modal.setContents(generateTable(data, targetInputName));

      break;
    default:
      modal.setContents(noMatchesFoundContent());
  }

  var modalHeight = (dataLength > 10) ? 500 : null;
  modal.setSizeModify({ width: null, height: modalHeight });

  modal.display();

  return modal;
}

function setPaginationButtons(modal, targetInputName) {
  const buttons = [
    {
      value: translations.translateString('COMMON.PREVIOUS'),
    },
    {
      value: translations.translateString('COMMON.NEXT'),
    },
  ];

  if (medsAPIService.hasPreviousPage()) {
    buttons[0].class = 'button-primary';

    buttons[0].onclick = function() {

      medsAPIService.previousPage()
        .then(function(response) {
          modal.setContents(generateTable(response, targetInputName));
          setPaginationButtons(modal, targetInputName);
        });
    }
  }

  if (medsAPIService.hasNextPage()) {
    buttons[1].class = 'button-primary';

    buttons[1].onclick = function() {
      medsAPIService.nextPage()
        .then(function(response) {
          modal.setContents(generateTable(response, targetInputName));
          setPaginationButtons(modal, targetInputName);
        });
    };
  }

  modal.setButtons(buttons);
}

function noMatchesFoundContent(invalidLocation = false) {

  var noMatches = document.createElement('div'),
      noMatchesDescription = document.createElement('div'),
      noMatchesHelper = document.createElement('span');

  nJ.addClass(noMatches, 'no-matches');

  noMatchesDescription.textContent = translations.translateString('MEDICATIONS.V2.FORM.MESSAGE.MEDICATION_SEARCH.NO_MATCHES');
  nJ.addClass(noMatchesDescription, 'description');
  noMatches.appendChild(noMatchesDescription);

  noMatchesHelper.textContent = translations.translateString(
      invalidLocation ? 'MEDICATIONS.V2.FORM.MESSAGE.MEDICATION_SEARCH.INVALID_LOCATION' : 'MEDICATIONS.V2.FORM.MESSAGE.MEDICATION_SEARCH.EXACT_MATCHES_ONLY'
  );
  nJ.addClass(noMatchesHelper, 'helper-text');
  noMatches.appendChild(noMatchesHelper);

  return noMatches;
}

function generateTable(data, targetInputName) {

  var headers = [
        { name: translations.translateString('MEDICATIONS.V2.MESSAGE.SEARCH_TABLE.GENERIC_NAME'), dataId: 'genericName' },
        { name: translations.translateString('MEDICATIONS.V2.MESSAGE.SEARCH_TABLE.TYPE'), dataId: 'type' },
        { name: translations.translateString('MEDICATIONS.V2.MESSAGE.SEARCH_TABLE.CLASS'), dataId: 'class' },
        { name: translations.translateString('MEDICATIONS.V2.MESSAGE.SEARCH_TABLE.BRAND'), dataId: 'brand' },
        { name: translations.translateString('MEDICATIONS.V2.MESSAGE.SEARCH_TABLE.STRENGTH'), dataId: 'strength' },
        { name: translations.translateString('MEDICATIONS.V2.MESSAGE.SEARCH_TABLE.MANUFACTURER'), dataId: 'manufacturer' }
      ],
      table = document.createElement('table'),
      columnCount = headers.length;

  const tableClasses = [
    'table',
    'table-striped',
    'table-hover',
    'no-bottom-margin'
  ];

  if(globals && globals.isRightToLeft) {
    tableClasses.push('dtx-table-rtl');
  }

  nJ.addClass(table, tableClasses);

  var row = table.insertRow(-1);
  for (var i = 0; i <= columnCount; i++) {
    var headerCell = document.createElement('th');
    headerCell.innerHTML = headers[i] ? headers[i]['name'] : '';
    nJ.addClass(headerCell, ['matchingResult__table-header']);
    row.appendChild(headerCell);
  }

  //Add the data rows.
  Object.keys(data).forEach(function (key) {
    row = table.insertRow(-1);
    for (var j = 0; j < columnCount; j++) {
      var cell = row.insertCell(-1);

      cell.textContent = data[key][headers[j]['dataId']];

      if (j === columnCount - 1) {
        cell = row.insertCell(-1);
        var choseBtn = document.createElement('button');
        choseBtn.textContent = translations.translateString('MEDICATIONS.V2.BUTTON.SEARCH_TABLE.CHOOSE');
        nJ.addClass(choseBtn, 'matchingResult__button');

        choseBtn.addEventListener('click', function () {
          var chooseEvent = new CustomEvent(getDrugChoseIdentifier(targetInputName), {
            detail: {
              medication:data[key],
              value:data[key]['genericName']
            },
            bubbles: true,
            cancelable: false
          });

          this.dispatchEvent(chooseEvent);
        });
        cell.appendChild(choseBtn);
      }
    }
  });

  return table;
}

clearAdministeredFields = function (event) {
  event.stopPropagation();
  event.preventDefault();
  clearFields('administered', this);
};

clearIntendedFields = function (event) {
  event.stopPropagation();
  event.preventDefault();

  clearFields('intended', this);
};

clearFields = function (type, foBu) {
  var fields = foBu.formElement.getElementsByClassName('INC-medications__' + type + '-field');

  // can clear if theres no attributes or donotclear is not set
  const canClear = attributes => !attributes || !attributes.donotclear;
  Array.prototype.forEach.call(fields, function (field) {
    if(canClear(field.attributes)) {
      foBu.clearField(field.foBuSettings);
    }
  });
};

duplicateAdministeredFields = function (event) {
  event.stopPropagation();
  event.preventDefault();
  //TODO Duplicate functionality needs to be refactored. Since if the field positions changes, or if u include any other extra field without 'INC-medications__intended-field'
  //this will break this code of duplication from administered to intended. Its should be referenced differently
  const foBu               = this;
  foBu.syncMedicationsDoseRowHiddenInputsValue();
  foBu.updateMedicationsDoseRowHiddenInputsClassName();
  const administeredFields = this.formElement.getElementsByClassName('INC-medications__administered-field');
  const intendedFields     = this.formElement.getElementsByClassName('INC-medications__intended-field');

  Array.from(administeredFields).forEach(function (field, i) {
    let value = field.value;

    if (field.foBuSettings.elementType && (field.foBuSettings.elementType.toLowerCase() === 'typeahead' || field.foBuSettings.elementType.toLowerCase() === 'inputwithbutton')) {
      value = field.foBuSettings.inputElement.value;
    }

    if(intendedFields[i]) {
      foBu.updateField(intendedFields[i].foBuSettings, value);
    }
  });

  foBu.validation.validate(foBu.settings.uid);
};

processInputsFunction = function(element, foBu) {

  if (element.foBuSettings.processInputs.compareTo) {
    var formElement     = foBu.formElement,
        getInputName    = foBu.getInputName,
        elementSettings = element.foBuSettings,
        compareTo       = elementSettings.processInputs.compareTo,
        comboValues     = [],
        name,
        comparator,
        styleTarget,
        match = true;

    if (compareTo.compareMultiple) {

      compareTo.compareMultiple
        .forEach(function(combo){

          var comboValue = '';

          combo.forEach(function(input){

            name = getInputName(input);

            comparator = formElement.querySelector('[name="' + name + '"]');
            comboValue += comparator.value;

          });
          comboValues.push(comboValue);
        });

      if(nJ.allArrayValuesAreEqual(comboValues) === false){
        match = false;
      }

      name        = getInputName(compareTo.styleTarget);
      styleTarget = formElement.querySelector('[name="' + name + '"]').parentElement.parentElement;

    } else {
      name = getInputName(compareTo.comparator);

      comparator = formElement.querySelector('[name="' + name + '"]');

      if (compareTo.styleTarget) {
        name        = getInputName(compareTo.styleTarget);
        styleTarget = formElement.querySelector('[name="' + name + '"]').parentElement;
      } else {
        styleTarget = comparator.parentElement;
      }

      if (element.value !== comparator.value) {
        match = false;
      }
    }

    if (match === false) {
      nJ.addClass(styleTarget, ['foBu__form-item--icon', 'icon--error']);
    } else {
      nJ.removeClass(styleTarget, ['foBu__form-item--icon', 'icon--error']);
    }
  }
};

// REFACTOR SUGGESTION: Move to irm-shared-functions.js
// There is litte difference between this and the one in equipmentForm.js so it should be possible to abstract it
submitRecord = function (values, wasEdited = false) {
  var administeredDrugId = $("#administeredDrugId_medications-record-form" ).val();
  var intendedDrugId = $("#intendedDrugId_medications-record-form" ).val();
  var drugIds = [administeredDrugId, intendedDrugId];

  return new Promise(function (resolve, reject) {
    fetchDrugDetails(drugIds)
      .then(response => {
        if (response) {
          var administeredGenericName = ( typeof response[0] !== 'undefined' && response[0].genericName !== '') ? response[0].genericName : '';
          var intendedGenericName = ( typeof response[1] !== 'undefined' && response[1].genericName !== '') ? response[1].genericName : '';

          var formUid        = tableOptions.uid,
            answerUuid       = values.answersId,
            recordUuid       = globals.recordUuid,
            errorCallback    = onDrugSubmissionErrorCallback,
            successCallback  = (data, params) => onDrugSubmissionSuccessCallback(data, params, wasEdited),
            isValueSet       = function(value) {
              if (value === 'undefined' || typeof value === 'undefined' || value === '') {
                return false;
              }
              return true;
            };

            if (!isValueSet(answerUuid)) {
              answerUuid = uuidWrapper(drugRecordNsUuid);
            }
            if (!isValueSet(recordUuid)) {
              recordUuid = uuidWrapper(incidentRecordNsUuid);
            }
            if (administeredGenericName.trim() === values.administeredDrug.trim()
              && intendedGenericName.trim() === values.intendedDrug.trim()) {
              resolve(
                  medsAPIService
                    .submitMedication(formUid, values, answerUuid, recordUuid, successCallback)
                    .catch(errorCallback)
              );
            } else {
              submitRecordErrorCallback('No matching medication found', reject);
            }
          }
      })
      .catch(reject);
  });
};

submitRecordErrorCallback = function(error, resolve) {
  window.hideLoadPopup();
  irmFunctions.showMessage(checkForErrorString(error, 'medications'), 'error');
  resolve(error);
};

onDrugSubmissionSuccessCallback = function(data, params, wasEdited) {
  const answersId           = data.data.SaveListOfDrugAnswers[0].id;
  const dataViewRecordIndex = params.dataViewRecordIndex;
  const editButton          = document.getElementById('edit-row-bottom_medications-cmt-data-display-row_' + dataViewRecordIndex);
  const deleteButton        = document.getElementById('delete-row-bottom_medications-cmt-data-display-row_' + dataViewRecordIndex);

  editButton && editButton.setAttribute('data-answers-id', answersId);
  deleteButton && deleteButton.setAttribute('data-answers-id', answersId);

  let message = translations.translateString('MEDICATIONS.FORM_TYPE.MEDICATION') + ' ' + params.values.administeredDrug + ' ';
  if(wasEdited) {
    message += translations.translateString('MEDICATIONS.SUCCESS.MEDICATION_UPDATED');
  } else{
    message += translations.translateString('MEDICATIONS.SUCCESS.MEDICATION_ADDED');
  }
  irmFunctions.showMessage(message);
};

onDrugSubmissionErrorCallback = function(error) {
  irmFunctions.showMessage(checkForErrorString(error), 'error');
};

onDrugDeletionSuccessCallback = function(params) {
  window.hideLoadPopup();
  params.deleteRecord(params.recordId);
  irmFunctions.showMessage(translations.translateString('MEDICATIONS.SUCCESS.MEDICATION_DELETED'));
};

onDrugDeletionErrorCallback = function(params) {
  window.hideLoadPopup();
  irmFunctions.showMessage(checkForErrorString(params.errors), 'error');
};

getDrugAnswersAndBuildTable = function() {
  return new Promise(function (resolve, reject) {
    // If the record is new and has no errors don't load existing medications data
    if (globals.isNewRecord === true && globals.isNewRecordWithErrors === false) {

      var buildContentTableParams = {
        tableOptions               : tableOptions,
        translations               : translations,
        cmdClass                   : ContentManagementDisplay
      };

      hideSuperfluousHeader();
      contentTable = irmFunctions.buildContentTable(domId, buildContentTableParams);
      resolve(contentTable);
    } else {
      medsAPIService
        .getDrugAnswers(globals.recordUuid)
        .then(data => {
          hideSuperfluousHeader();
          getDrugAnswersAndBuildTableSuccessCallback(data).then(resolve);
        })
        .catch(function(error){
          getDrugAnswersAndBuildTableErrorCallback(error, reject);
        });
    }
  });
};

function fetchDrugDetails(ids) {
  return Promise.all(ids.map(id => medsRESTService.getDrugDetails(id)));
}

function getContentTable(answers) {
  const existingFormData = restructureExistingData(answers);
  const buildContentTableParams = {
    existingFormData : existingFormData,
    tableOptions     : tableOptions,
    translations     : translations,
    cmdClass         : ContentManagementDisplay
  };

  return irmFunctions.buildContentTable(domId, buildContentTableParams);
}

getDrugAnswersAndBuildTableSuccessCallback = function (data) {
  const answers = data.data.RequestListOfDrugAnswers;

  return new Promise((resolve, reject) => {
      fetchDrugDetails(answers
        .reduce((ids, answer) => {
          ['administeredDrug', 'correctDrug'].forEach(columnName => {
            const id = answer[columnName].drugId;
            if (ids.indexOf(id) === -1) ids.push(id);
          });
          return ids;
        }, [])
        .filter(id => id)
      )
        .then(drugDetails => {
          const answersWithDrugDetails = answers.map(answer => {
            ['administeredDrug', 'correctDrug'].forEach(columnName => {
              const drugId = answer[columnName].drugId;
              const answerDrugDetails = drugDetails.find(drug => drug.uuid === drugId);
              answer[columnName].drug = answerDrugDetails;
            });
            return answer;
          });
          contentTable = getContentTable(answersWithDrugDetails);
          resolve(contentTable);
        })
        .catch(reject);
  });
};

getDrugAnswersAndBuildTableErrorCallback = function(error, resolve) {
  window.hideLoadPopup();
  irmFunctions.showMessage(checkForErrorString(error, 'medications'), 'error');
  resolve(error);
};

restructureExistingData = function (data) {
  // Maps out medications from data array.
  return data.map(function (medicationResult) {
    // Creates a flat object with properties such as administeredDrug, intendedDrug and importantFactors.
    return ['administered', 'correct'].reduce(function (carry, incidentMedArg) {
      var thisMed     = medicationResult[incidentMedArg + 'Drug'],
          incidentMed = (incidentMedArg === 'correct') ? 'intended' : incidentMedArg;

      var drugDetails = {
        AdministrationRoute           : 'route',
        AdministrationDosageValue     : 'quantity',
        AdministrationDosageUnit      : 'unit',
        FormAdministered              : 'form',
        BnfClassificationAdministered : 'bnfClassification',
        DrugId                        : 'drugId',
        BatchNumber                   : 'batchNumber',
        BnfClassification             : 'bnfClassification',
        ClinicalTrial                 : 'clinicalTrial',
        EthicsCommitteeNameReference  : 'ethicsCommitteeNameReference',
        ManufacturedSpecial           : 'manufacturedSpecial',
        ParallelImport                : 'parallelImport'
      };

      var assignedDrug = {
        Drug         : 'genericName',
        Brand        : 'brand',
        Manufacturer : 'manufacturer',
        Class        : 'class',
        Type         : 'type',
        Strength     : 'strength',
        Supplier     : 'supplier',
        SourceId     : 'sourceId'
      };

      // Cycles through administration properties, assigning them from the requested medication object.
      return Object.assign(carry, Object.entries(drugDetails).reduce(function (administration, entry) {
        administration[incidentMed + entry[0]] = thisMed[entry[1]];
        return administration;
      }, {}), (typeof thisMed.drug !== 'undefined' && thisMed.drug !== null ? Object.entries(assignedDrug)
        .reduce(function (drug, entry) {
          drug[incidentMed + entry[0]] = thisMed.drug[entry[1]];
          return drug;
        }, {}) : {}));
    }, {
      importantFactors        : medicationResult.otherImportantFactors,
      stageErrorOccurred      : medicationResult.stageOfError,
      typeOfError             : medicationResult.typeOfError,
      notes                   : medicationResult.notes,
      answersId               : medicationResult.id,
      adrId                   : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.id : null),
      adrDateReactionStarted  : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.reactionStartDateAst : null),
      adrDateReactionStopped  : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.reactionStopDateAst : null),
      frequencyWrong          : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.frequencyOfWrongMedication : null),
      drugReaction            : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.drugReactionManifestation : null),
      errorDetectedBy         : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.errorDetectedBy : null),
      errorCommittedBy        : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.errorCommittedBy : null),
      didDrugReactionReappear : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.appearedWhenReadministered : null),
      adrOrganSystem          : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.organSystemFields : null),
      naranjoTotalScore       : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.naranjoTotalScore : null),
      adrActionTaken          : (medicationResult.adverseDrugReaction ? medicationResult.adverseDrugReaction.actionTaken : null),
      dateFirstUsed           : medicationResult.dateFirstUsed,
      dateLastUsed            : medicationResult.dateLastUsed,
      reportedToManufacturer : medicationResult.reportedToManufacturer,
      dateReportedToManufacturer  : medicationResult.dateReportedToManufacturer,
      manufacturerRef : medicationResult.manufacturerRef,
      isStillAdministered : medicationResult.isStillAdministered,
      frequency: medicationResult.frequency,
      productExpiryDate: medicationResult.productExpiryDate,
      actionTaken: medicationResult.actionTaken,
      adrLessened: medicationResult.adrLessened,
      adrReappeared: medicationResult.adrReappeared,
    });
  });
};

getMedicationSearchResults = function(targetInput) {

  window.displayLoadPopup();

  medsAPIService
    .getDrugSearchResults(targetInput.value)
    .then(response => {
      searchResultSuccessCallback(response, targetInput);
    })
    .catch(searchResultErrorCallback);
};

searchResultSuccessCallback = function(medicationUniq, targetInput) {
  window.hideLoadPopup();
  // Pass drug choice event identifier into modal generator function, where ideally the modal functions would be setup.
  searchModal = showSearchResultsDialog(medicationUniq, targetInput);
};

searchResultErrorCallback = function(error){
  window.hideLoadPopup();
  irmFunctions.showMessage(checkForErrorString(error, 'medications'), 'error');
};

// This is to standardise the event id.
getDrugChoseIdentifier = function(targetInputName) {
  return 'onChooseDrugEvent_' + targetInputName;
};

drugChoseEventHandler = function(targetInput, updateDependentProps, foBu) {

  var onDrugChosenEventIdentifier = getDrugChoseIdentifier(targetInput.name);

  document.addEventListener(onDrugChosenEventIdentifier, function(event) {
    if (searchModal) {
      searchModal.CloseFloatingControl();
    }
    targetInput.value = event.detail.value;
    updateDependentProps(event.detail.medication,foBu);
  });

};

function checkForErrorString(error) {
  if(!error || (typeof error !== 'string' && !error.responseText)) {
    return 'There was an error with the medications service.';
  }
  return error;
}

formStructure = {
  class: FormBuilderStructure,
  data: {
    initInputWithButton   : initInputWithButton,
  }
};

tableOptions = {
  isEditable       : irmFunctions.isEditable,
  uid              : uidPrefix + '-cmt-data-display',
  formType         : 'Medication',
  formTypeTextKey  : 'medication',
  displayStriping  : 'odd',
  newButtonClasses : {
    buttonIds : ['new-Medication-button-top', 'new-Medication-button-bottom'],
    class    : 'cmt--hidden'
  },
  contentDisplaySettings : {
    formAttributes : {
      class : uidPrefix + 'cmt__data-display'
    },
    inputClass        : 'form-control',
    structure         : new MedsDisplayStructure(),
    isRecordDisplay   : true,
    callableFunctions : {
      deleteButtonAction : instantiateDeleteMedicationDialogue
    },
    processInputsFunction : processInputsFunction
  },
  contentClass        : {
    options          : {
      uid               : uidPrefix + '-record-form',
      formModuleName    : function() { return translations.translateString('MEDICATIONS.PLURAL') },
      formType          : 'Medication',
      formTypeTextKey   : 'medication',
      formAttributes    : {},
      inputClass        : 'form-control',
      structure         : new formStructure.class(formStructure.data),
      callableFunctions : {
        duplicateAdministeredFields : duplicateAdministeredFields,
        clearAdministeredFields : clearAdministeredFields,
        clearIntendedFields : clearIntendedFields,
        cancelButtonAction : instantiateCancelFormDialogue
      },
      submitRecord : submitRecord
    }
  }
};

module.exports = function (id, renderForm, callback) {
  const options = {
    uuid             : uuidWrapper,
    deleteMedication : medsAPIService.deleteMedication
  };

  domId = id;

  if (renderForm === undefined) {
    renderForm = true;
  }

  if (callback !== undefined) {
    callback(tableOptions, options);
  }

  // If Medications is intended to run, it requires loading some resources.
  return new Promise(function (resolve, reject) {
    translations.getTranslations()
      .then(function(){
        if (renderForm) {
          getDrugAnswersAndBuildTable()
            .then(function (contentTable) {
              options.contentTable = contentTable;
              resolve(contentTable);
            })
            .catch(reject);
        }
      })
      .catch(reject);
  });
};

// Exposing functionality outside of webpack, for use with PHP-based meds forms
window.getMedicationSearchResults = getMedicationSearchResults;
window.closeMedicationsSearchModal = function()
{
  if (searchModal) {
    searchModal.CloseFloatingControl();
  }
};
